import { debounce } from "lodash";
import { format as dateFormat, parseISO } from "date-fns";
import { FormHelperText, InputLabel, SxProps, TextField, Theme } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as DatePickerInput } from "@mui/x-date-pickers/DatePicker";
interface IDatePickerProps {
  id: any;
  value: any;
  label: string;
  error?: any;
  format?: string;
  onChange: any;
  handleBlur?: any;
  disabled?: boolean;
  disablePast?: boolean;
  small?: boolean;
  sx?: SxProps<Theme>
}

const inputFormat = "yyyy-MM-dd"; //MM-dd-yyyy

export default function DatePicker({
  id,
  value,
  label,
  error,
  format,
  disabled,
  onChange,
  handleBlur,
  disablePast,
  small,
  sx
}: IDatePickerProps) {
  const handleChange = debounce((date: any) => {
    if (Object.prototype.toString.call(date) === "[object Date]") {
      // it is a date
      if (isNaN(date)) {
        onChange("invalid");
        // write here code for error
      } else {
        const formatedDate = dateFormat(date, inputFormat);
        onChange(formatedDate);
      }
    } else {
      onChange(null);
    }
  }, 700);

  let date = value;


  /*
  if (value?.includes(":")) {
    date = dateFormat(new Date(value), inputFormat);
  }
  */

  //date = dateFormat(new Date(value), inputFormat);


  return ( 
    <div className="form-group">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <InputLabel>{label}</InputLabel>
        <DatePickerInput
          value={value ? parseISO(date) : null}
          disabled={disabled}
          disablePast={disablePast}
          onChange={(e: any) => handleChange(e)}
          inputFormat={format || inputFormat}
          renderInput={(params) => (
            <>
            <TextField
              {...params}
              id={id}
              fullWidth
              size={small ? "small" : undefined}
              onBlur={handleBlur}
              sx={sx}
              error={error ? true : false}
            />
            {error && (
              <FormHelperText error>
                {error}
             </FormHelperText>
            )}
             
            </>
            
          )}
        />
      </LocalizationProvider>
    </div>
  );
}
